// extracted by mini-css-extract-plugin
module.exports = {"stage":"Stage_stage__3G8pg","hero":"Stage_hero__2pryr","fadeIn":"Stage_fadeIn__m7zVT","scaleXin":"Stage_scaleXin__21HD6"};